import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from "rxjs";
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TraxGuard implements CanActivate {

  constructor(
    private authenticationService: AuthenticationService, 
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    this.authenticationService.setCompanyFromRoute(route.queryParamMap);

    const redirect = state.url.replace(/^(\/trax)/, "");
    this.router.navigateByUrl(redirect);
    return false;
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

}
